<!--
 * @Description: 巡检计划详情弹窗
-->
<template>
  <ykc-drawer
    title="巡检计划详情"
    :show.sync="drawerVisible"
    :on-close="onDrawerClose"
    size="800px">
    <template #footer>
      <div class="drawer-button-wrap">
        <ykc-button type="plain" @click="drawerVisible = false">关闭</ykc-button>
      </div>
    </template>
    <div class="drawer-main-body" v-if="drawerVisible">
      <div v-if="loading" class="detail-loading">
        <i class="el-icon-loading"></i>
        加载中...
      </div>
      <div v-else-if="detailData" class="detail-content">
        <!-- 基础信息 -->
        <div class="detail-section">
          <div class="detail-section-title">基础信息</div>
          <ykc-detail-plus :labelWidth="140">
            <ykc-detail-item-plus label="巡检计划编码">
              {{ detailData.planCode || '--' }}
            </ykc-detail-item-plus>
            <ykc-detail-item-plus label="状态">
              <span :class="detailData.status === 1 ? 'status-active' : 'status-expired'">
                {{ detailData.status === 1 ? '未过期' : '已过期' }}
              </span>
            </ykc-detail-item-plus>
            <ykc-detail-item-plus label="巡检人">
              {{ detailData.creatorName || '--' }}
            </ykc-detail-item-plus>
            <ykc-detail-item-plus label="巡检时间">
              {{ formatDate(detailData.inspectionDate) }}
            </ykc-detail-item-plus>
            <ykc-detail-item-plus label="巡检城市">
              {{ detailData.cityName || '--' }}
            </ykc-detail-item-plus>
            <ykc-detail-item-plus label="巡检电站手动调整原因" v-if="detailData.adjustReason">
              {{ detailData.adjustReason }}
            </ykc-detail-item-plus>
          </ykc-detail-plus>
        </div>

        <!-- 巡检电站列表 -->
        <div class="detail-section">
          <div class="detail-section-title">巡检电站列表</div>
          <ykc-table :data="stationTableData" :columns="stationColumns"></ykc-table>
        </div>
      </div>
    </div>
  </ykc-drawer>
</template>

<script>
  import { inspectionPlanApi } from '@/service/apis';

  export default {
    name: 'InspectionPlanDetail',
    props: {
      visible: { type: Boolean, default: false },
      detailId: { type: [Number, String], default: null },
    },
    data() {
      return {
        loading: false,
        detailData: null,
      };
    },
    computed: {
      drawerVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit('update:visible', val);
        },
      },
      stationTableData() {
        if (!this.detailData) return [];
        const planList = this.detailData.planStationList || [];
        const aiList = this.detailData.aiStationList || [];
        const maxLen = Math.max(planList.length, aiList.length);
        const rows = [];
        for (let i = 0; i < maxLen; i++) {
          const plan = planList[i];
          const ai = aiList[i];
          rows.push({
            sort: i + 1,
            planStationName: plan ? plan.stationName : '--',
            planMileage: plan ? plan.segmentMileage : '--',
            aiStationName: ai ? ai.stationName : '--',
            aiMileage: ai ? ai.segmentMileage : '--',
          });
        }
        return rows;
      },
      stationColumns() {
        return [
          { label: '巡检顺序', prop: 'sort', minWidth: '80px', align: 'center' },
          {
            label: `计划巡检电站（总里程${this.detailData?.totalMileage || 0}km）`,
            prop: 'planStationName',
            minWidth: '180px',
          },
          {
            label: '计划里程',
            prop: 'planMileage',
            minWidth: '90px',
            align: 'center',
          },
          {
            label: `智能建议巡检电站（总里程${this.detailData?.aiTotalMileage || 0}km）`,
            prop: 'aiStationName',
            minWidth: '180px',
          },
          {
            label: '智能建议里程',
            prop: 'aiMileage',
            minWidth: '90px',
            align: 'center',
          },
        ];
      },
    },
    watch: {
      detailId: {
        handler(val) {
          if (val) {
            this.loadDetail();
          }
        },
        immediate: true,
      },
    },
    methods: {
      formatDate(date) {
        if (!date) return '--';
        if (typeof date === 'string') return date.substring(0, 10);
        const d = new Date(date);
        if (Number.isNaN(d.getTime())) return '--';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      },
      loadDetail() {
        this.loading = true;
        inspectionPlanApi
          .getDetail(this.detailId)
          .then(res => {
            this.detailData = res;
          })
          .catch(err => {
            console.error('加载巡检计划详情失败:', err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      onDrawerClose() {
        this.detailData = null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .drawer-main-body {
    padding: 20px;

    .detail-loading {
      text-align: center;
      padding: 40px 0;
      color: #909399;
    }

    .detail-section {
      margin-bottom: 24px;

      .detail-section-title {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        margin-bottom: 16px;
        padding-bottom: 8px;
        border-bottom: 1px solid #ebeef5;
      }

      .status-active {
        color: #38a169;
        font-weight: 500;
      }

      .status-expired {
        color: #909399;
        font-weight: 500;
      }
    }
  }
</style>
